import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Button, Spinner } from "react-bootstrap";
import PaginationLink from "../Components/PaginationLink";
import { getAllTransaction } from "./ApiCall";
import InnerHTML from "dangerously-set-html-content";
import Loader from "../Pages/Loader";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../Components/ScrollToTop";

function Transactions() {
  const [allTransaction, setAllTransaction] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [error, setError] = useState(false);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [holderclick, setHolderClick] = useState(1);
  const [orderbydesc, setOrderbydesc] = useState(null);

  const fetchData = async (page, pricesorder) => {
    try {
      setLoading(true);
      const transactionResponse = await getAllTransaction(
        page,
        itemsPerPage,
        pricesorder,
      );
      setTotalItems(transactionResponse?.data?.totalItems);
      setAllTransaction(transactionResponse?.data.data);
      setError(false);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.sortDec = () => {
      setHolderClick((prevHolderClick) => prevHolderClick + 1);
      if (holderclick % 3 === 1) {
        getAllTransaction(currentPage, itemsPerPage, "ASC");
        setOrderbydesc("ASC");
      } else if (holderclick % 3 === 2) {
        getAllTransaction(currentPage, itemsPerPage, "DESC");
        setOrderbydesc("DESC");
      } else {
        getAllTransaction(currentPage, itemsPerPage, false);
        setOrderbydesc(false);
      }
    };

    fetchData(currentPage, orderbydesc);
  }, [currentPage, orderbydesc]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  window.Navigateto = (tabName) => {
    navigate(tabName);
  };

  return (
    <>
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <h2> All Transactions</h2>
                </Col>
                <Col xl="12" md="12">
                  <div className="table-container">
                    <div className="table-inner-container">
                      <p className="heading-p">
                        Total Transactions found {""}
                        {totalItems && totalItems
                          ? totalItems?.slice(0, 2) +
                            "," +
                            totalItems
                              ?.slice(2)
                              .replace(/(\d{3})(?=\d)/g, "$1,")
                          : "--"}
                      </p>

                      {loading ? (
                        <div>
                          <Loader />
                        </div>
                      ) : error ? (
                        <div className="errorMsg">
                          <span>
                            Failed to load transactions Please Try Again.
                          </span>
                        </div>
                      ) : (
                        <InnerHTML key={allTransaction} html={allTransaction} />
                      )}

                      <div className="pagination-container">
                        <PaginationLink
                          itemsPerPage={itemsPerPage}
                          totalItems={totalItems}
                          onPageChange={handlePageChange}
                          // paginationId={paginationId}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
}

export default Transactions;
